/** @jsxImportSource @emotion/react */
import { Buttons } from '@zip/business-components';
import * as styles from './NavButtons.styles';

type NavButtonsProps = {
  canGoBack: boolean;
  canContinue: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onContinue: () => void;
  backLabel?: string;
  continueLabel?: string;
};

export function NavButtons({
  canGoBack,
  canContinue,
  isSubmitting,
  onBack,
  onContinue,
  backLabel = 'Back',
  continueLabel = 'Continue',
}: NavButtonsProps): JSX.Element {
  return (
    <>
      <div css={styles.navButtonsWrapper}>
        {canGoBack && (
          <Buttons.Primary
            className="backButton"
            type="button"
            variant="text"
            onClick={onBack}
            disabled={isSubmitting}
          >
            {backLabel}
          </Buttons.Primary>
        )}

        <Buttons.Primary
          className="continueButton"
          variant="contained"
          onClick={onContinue}
          disabled={!canContinue || isSubmitting}
          loading={isSubmitting}
        >
          {continueLabel}
        </Buttons.Primary>
      </div>
    </>
  );
}
